module.exports = __webpack_public_path__ + "static/media/timber03.2f0fcb2c.jpg";